import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import '../styles/StoreInfo.css';

// Фикс для маркеров на карте
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
    iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const StoreInfo = () => {
    // Пример данных о магазинах
    const stores = [
        {
            id: 1,
            name: 'Магазин Карусель - Закамск',
            address: 'улица Маршала Рыбалко, 91',
            phone: '+7 (965) 575-71-04',
            coordinates: [58.012000, 55.969588],
            workingHours: '10:00 - 20:00'
        },
        {
            id: 2,
            name: 'Магазин Карусель - Старые Водники',
            address: 'улица Каляева, 20',
            phone: '+7 (965) 575-71-04',
            coordinates: [58.029231, 56.018231],
            workingHours: '10:00 - 20:00'
        },
        {
            id: 3,
            name: 'Магазин Карусель - Парковый',
            address: 'улица Комиссара Пожарского, 10',
            phone: '+7 (965) 575-71-04',
            coordinates: [57.996606, 56.155476],
            workingHours: '10:00 - 20:00'
        }
    ];

    return (
        <Container className="mt-4">
            <h2 className="text-center mb-4">Наши магазины</h2>
            
            <Row className="mb-4">
                <Col md={6}>
                    <Card className="h-100">
                        <Card.Body>
                            <Card.Title>О компании</Card.Title>
                            <Card.Text>
                                Магазин Карусель - это сеть магазинов одежды, обуви и игрушек для всей семьи. 
                                Мы предлагаем широкий ассортимент качественных товаров по доступным ценам.
                            </Card.Text>
                            <Card.Text>
                                Наша миссия - сделать шоппинг приятным и удобным для каждого клиента.
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={6}>
                    <Card className="h-100">
                        <Card.Body>
                            <Card.Title>Контактная информация</Card.Title>
                            <Card.Text>
                                <strong>Телефон:</strong> +7 (965) 575-71-04<br />
                                <strong>Email:</strong> karyseli59@mail.ru<br />
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row className="mb-4">
                <Col>
                    <Card>
                        <Card.Body>
                            <Card.Title>Наши магазины на карте</Card.Title>
                            <div style={{ height: '400px', width: '100%' }}>
                                <MapContainer 
                                    center={[58.012000, 55.969588]} 
                                    zoom={11} 
                                    style={{ height: '100%', width: '100%' }}
                                    attributionControl={false}
                                >
                                    <TileLayer
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    />
                                    {stores.map(store => (
                                        <Marker 
                                            key={store.id} 
                                            position={store.coordinates}
                                        >
                                            <Popup>
                                                <div>
                                                    <h6>{store.name}</h6>
                                                    <p>Адрес: {store.address}</p>
                                                    <p>Телефон: {store.phone}</p>
                                                    <p>Часы работы: {store.workingHours}</p>
                                                </div>
                                            </Popup>
                                        </Marker>
                                    ))}
                                </MapContainer>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row>
                {stores.map(store => (
                    <Col md={6} key={store.id} className="mb-4">
                        <Card>
                            <Card.Body>
                                <Card.Title>{store.name}</Card.Title>
                                <Card.Text>
                                    <strong>Адрес:</strong> {store.address}<br />
                                    <strong>Телефон:</strong> {store.phone}<br />
                                    <strong>Часы работы:</strong> {store.workingHours}
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default StoreInfo; 